import angular from 'angular'
import planningService from './planning.service'

export default angular
  .module('ellipsis.planning', [])
  .service('planningService', planningService)
